<template>
  <v-container>
    <v-row class="justify-center">
      <v-col
        cols="9"
      >
        <v-row>
          <h3 class="font_3" style="line-height:1.2em;font-size:80px;color:#008afc">
            Olá,
          </h3>
        </v-row>
        <v-row>
          <h4 class="font_4" style="font-size:36px; line-height:1.2em;color:#8c8b8b;
          font-weight:bold">
            aqui lhe ajudaremos a controlar seus horários de atendimento.
          </h4>
        </v-row>
        <v-spacer></v-spacer>
        <br/>
        <v-row justify="space-around">
          <v-avatar
            color="indigo"
            size="150"
          >
            <img
              src="../../assets/avatar_1.png"
              alt="Joelson"
            >
          </v-avatar>

          <v-avatar
            size="150"
          >
            <img
              src="../../assets/avatar_2.png"
              alt="Braga"
            >
          </v-avatar>

          <v-avatar
            color="red"
            size="150"
          >
            <img
              src="../../assets/avatar_3.png"
              alt="Kinder"
            >
          </v-avatar>
        </v-row>
        <br/>
        <h1 style="font-size:34px; line-height:1.4em">
          Com o <span style="color: #008afc">Agenda Plus</span>
          você terá maior facilidade para controlar sua agenda semanal.
        </h1>
        <v-spacer></v-spacer>
        <h1 style="font-size:34px; line-height:1.4em;color: #ff00ff">
          Tudo em apenas um lugar!
        </h1>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    variavel: 'Olá,\nControle seus horários de atendimento',
  }),
};
</script>
